import Vue from "vue";
import { SET_FILTER } from "./mutations.type";
import { REMOVE_FILTER } from "./mutations.type";

export default {
  namespaced: true,
  state: {
    listenfilter: {},
  },
  mutations: {
    [SET_FILTER](state, val) {
      state.listenfilter = val;
    },
    // [REMOVE_FILTER](state, filterId) {
    //   if (Object.prototype.hasOwnProperty.call(state.listenfilter, filterId)) {
    //     Vue.delete(state.listenfilter, filterId);
    //   }
    // },
  },
};
